module.exports = __webpack_public_path__ + "static/training-b1574cfdb00cf0afb8fa1884e46a580b.png";